import styled from "styled-components"

import { maxWidth } from "utils"

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const MBGLogo = styled.div`
  font-family: Monoline, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 2.7rem;
  margin: 3rem 0;
  color: #000;
  ::after {
    content: "Mindbodygreen";
  }

  ${maxWidth.tablet`
    margin: 2rem 0;
    font-size: 2.2rem;
  `}
`

export const Content = styled.div`
  width: 100%;
  max-width: 40rem;
  margin: 2rem 4rem;
  text-align: center;

  ${maxWidth.tablet`
    margin: 1.5rem 2rem;
  `}
`

export const Title = styled.h2`
  font-size: 2.8rem;
  line-height: 3.2rem;
  font-weight: 400;
  font-family: "Maax", "Helvetica Neue", Helvetica, Arial, sans-serif;
  letter-spacing: 0.1rem;
  text-align: center;
  color: #000;

  ${maxWidth.tablet`
    font-size: 2.2rem;
    line-height: 2.6rem;
  `}
`

export const Text = styled.p`
  text-align: center;
  max-width: 32.5rem;
  margin: 2rem auto;
  line-height: 2.3rem;
`

export const ErrorText = styled(Text)`
  color: #b6471f;
`

export const CancelButton = styled.button`
  background: none;
  border: none;
  color: #000;
  font-size: 1.6rem;
  font-family: "Maax", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 0.5rem;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
`

export const ResendButton = styled.button`
  background: none;
  border: none;
  color: #000;
  font-size: 1.6rem;
  cursor: pointer;
  text-decoration: underline;
`

export const Terms = styled.div`
  margin: 3rem 0 0 0;
  font-size: 1.2rem;
  line-height: 2.16rem;
  text-align: center;
`
